import React from 'react';
import { Button, ButtonSize } from '@benzinga/core-ui';
import styled from '@benzinga/themetron';
import i18n from '@benzinga/translate';
import { useTranslation } from 'react-i18next';

interface Props {
  link?: string;
  size?: ButtonSize;
}

export const QuoteSellButton: React.FC<Props> = ({
  link = 'https://www.benzinga.com/go/start-investing/?pl=sell',
  size,
}) => {
  const { t } = useTranslation('common', { i18n });

  return (
    <Container className="sell-button" href={link} rel="noreferrer" target="_blank">
      <Button size={size} variant="danger">
        {t('Buttons.sell')}
      </Button>
    </Container>
  );
};

export default QuoteSellButton;

const Container = styled.a`
  &.sell-button {
    display: block;

    button {
      width: 100%;
    }
  }
`;
